import {get} from "lodash";
import {getBoolean, getInteger, getObject, getString} from "Core/helpers/data";
import {SORT_ORDER} from "Core/const/global";

/**
 * Unique Redux store key associated to this reducer
 * IMPORTANT: All reducers must export this value!
 * @type {string}
 */
export const reducerStoreKey = 'messageDeliveries';

// Define reducer types handled by this reducers
export const REDUCER_TYPES = {
	RESET: '@messageDeliveries/reset',
	SET_LIST_DATA: '@messageDeliveries/set_list_data',
	SET_LIST_FILTER: '@messageDeliveries/set_list_filter',
	CLEAR_LIST_DATA: '@messageDeliveries/clear_list_data',
};

// Define action creators for all reducer types
export const actionCreators = {
	reset: () => ({type: REDUCER_TYPES.RESET}),
	/**
	 * @param {IoJsonFetchResponseObject} messageDeliveriesListData
	 * @return {{type: string, listData: IoJsonFetchResponseObject}}
	 */
	
	setMessageDeliveriesListData: messageDeliveriesListData => ({
		type: REDUCER_TYPES.SET_LIST_DATA, 
		listData: messageDeliveriesListData
	}),
	setMessageDeliveriesListFilter: messageDeliveriesListFilter => ({
		type: REDUCER_TYPES.SET_LIST_FILTER, 
		filter: messageDeliveriesListFilter
	}),
	clearMessageDeliveriesListData: () => ({type: REDUCER_TYPES.CLEAR_LIST_DATA}),
};

/**
 * Initial reducer state
 * IMPORTANT: All reducers must export initial state object!
 * @type {Object<string, any>}
 */
export const initialState = {
	/** @type {IoJsonFetchResponseObject} */
	listData: null,
};

// Reducer function
const reducer = (state = {...initialState}, action) => {
	switch (action.type) {
		case REDUCER_TYPES.RESET: return { ...initialState };

		case REDUCER_TYPES.SET_LIST_DATA: return {...state, listData: action.listData};
		case REDUCER_TYPES.SET_LIST_FILTER: return {
			...state, 
			listData: {...getObject(state.listData), filter: action.filter}
		};
		case REDUCER_TYPES.CLEAR_LIST_DATA: return {...state, listData: initialState.listData};

		default: return state;
	}
};

// Selectors
export const selectors = {
	getMessageDeliveriesList: state => get(state, [reducerStoreKey, 'listData', 'data']),
	getMessageDeliveriesListPagination: state => ({
		perPage: getInteger(state, [reducerStoreKey, 'listData', 'perPage']),
		pageNo: getInteger(state, [reducerStoreKey, 'listData', 'pageNo']),
		totalRows: getInteger(state, [reducerStoreKey, 'listData', 'totalResults']),
		isLastPage: getBoolean(state, [reducerStoreKey, 'listData', 'isLastPage'])
	}),
	getMessageDeliveriesListSort: state => ({
		sortBy: get(state, [reducerStoreKey, 'listData', 'sortBy']),
		sortDir: getString(state, [reducerStoreKey, 'listData', 'sortDir'], SORT_ORDER.ASC)
	}),
	getMessageDeliveriesListFilter: state => get(state, [reducerStoreKey, 'listData', 'filter'], null),
};

export default reducer;